import { canViewAgents } from '@/general/src/auth/can.js'
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'
import { adminAgentEditRoute, adminAgentNewBatchRoute, adminAgentNewRoute } from '@/webapp/src/lib/routes.js'
import { SectionWrapper } from '@/webapp/src/lib/sectionWrapper.js'
import { trpc } from '@/webapp/src/lib/trpc.js'
import { Block, Button, Buttons, Segment, Table } from '@/webapp/src/lib/uninty.components.js'

export const AdminAgentListPage = withPageWrapper({
  title: 'Агенты',
  Layout: GeneralLayout,
  authorizedAdminsOnly: true,
  checkAccess: ({ ctx }) => canViewAgents(ctx.me.admin),
})(() => {
  return (
    <Block fcnw>
      <Segment
        title="Агенты"
        size="m"
        desc={
          <Buttons>
            <Button as="a" href={adminAgentNewRoute.get()}>
              Новый агент
            </Button>
            <Button as="a" href={adminAgentNewBatchRoute.get()}>
              Много новых агентов
            </Button>
          </Buttons>
        }
      >
        <SectionWrapper
          useInfiniteQuery={() =>
            trpc.getAgentsForAdmin.useInfiniteQuery(
              {},
              {
                getNextPageParam: (lastPage) => {
                  return lastPage.nextCursor
                },
              }
            )
          }
          setProps={({ infiniteQueryResult }) => ({
            agents: infiniteQueryResult.data?.pages.flatMap((page) => page.agents) ?? [],
            infiniteQueryResult,
          })}
        >
          {({ agents, infiniteQueryResult }) => {
            return (
              <Table
                records={agents}
                href={(record) => adminAgentEditRoute.get({ agentSn: record.sn })}
                columns={[
                  { heading: 'SN', body: (record) => record.sn, width: 70 },
                  {
                    heading: 'Организация',
                    body: (record) => record.organizationLabel,
                    width: 200,
                  },
                  { heading: 'Имя', body: (record) => record.name, width: 200 },
                  { heading: 'Почта', body: (record) => record.email, width: 200 },
                ]}
                loadMore={() => {
                  if (!infiniteQueryResult.isFetchingNextPage && infiniteQueryResult.hasNextPage) {
                    void infiniteQueryResult.fetchNextPage()
                  }
                }}
                hasMore={infiniteQueryResult.hasNextPage}
              />
            )
          }}
        </SectionWrapper>
      </Segment>
    </Block>
  )
})
